import { storage, db } from '@/firebase.js';
export default({
  state:{
    categoryList: [],
    currName: '',
    currImage: [],
    uploadMessage: '',
    uploading: false,
    showMessage: false,
    uploadFilesList: [],
    currCategory: '',
    totalFiles: 0,
    doneFiles: 0
  },
  mutations:{
    addCategory(state){
      state.uploadMessage = `Dodano kategorie "${state.currName}" do listy kategorii.`;
      let converted = state.currName.split('');
      let replacedLetters = converted.map(l=>{
        if(l === 'ł'){
          return 'l';
        }
        else if(l === 'ą'){
          return 'a';
        }
        else if(l === 'ę'){
          return 'e';
        }
        else if(l === 'ś'){
          return 's';
        }
        else if(l === 'ó'){
          return 'o';
        }
        else if(l === 'ż'){
          return 'z'
        }
        else if(l === 'ź'){
          return 'z'
        }
        else{
          return l;
        }
      })
        let res_string = replacedLetters.join('').toLowerCase();
        let translatedName = res_string.replace(/\s/g, '');
      state.currImage.forEach(image=>{
        let storageRef = storage.ref(`szkloCategories/${image.name}`);
        state.uploading = !state.uploading;
        let test = state.currName;
        storageRef.put(image)
        .then((snapshot)=>{
          snapshot.ref.getDownloadURL().then(url=>{
            db.collection('szkloCategories').doc().set({
              name: test,
              url,
              to: translatedName
            })
            state.uploading = !state.uploading;
            this.dispatch('bindCategories')
            state.showMessage = true;
            setTimeout(()=>{
              state.showMessage = false;
            }, 3000)
          })
        })
      })
      state.currImage = [];
      state.currName = '';
    },
    setName(state, payload){
      state.currName = payload;
    },
    selectFile(state, payload){
      let file = payload.target.files[0];
      state.currImage.push(file);
    },
    selectMultipleFiles(state, payload){
      payload.target.files.forEach(file=>{
        state.uploadFilesList.push(file);
      })
    },
    uploadImages(state){
      state.totalFiles = 0;
      state.doneFiles = 0;
      state.totalFiles = state.uploadFilesList.length;
      state.uploadFilesList.forEach(file=>{
        let storageRef = storage.ref(`${state.currCategory}/${file.name}`);
        storageRef.put(file)
        .then(snapshot=>{
          snapshot.ref.getDownloadURL().then(url=>{
            db.collection(state.currCategory).doc().set({
              name: file.name,
              url
            })
          })
          state.doneFiles = state.doneFiles+1;
        })
      })
      state.uploadFilesList = [];
    },
    selectedCategory(state, element){
      state.currCategory = element.target.value;
    }
  },
  actions:{},
  getters:{}
})